export default __webpack_public_path__ + "static/media/logo.47b6cf21.svg";